// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, classNames, Tabs, Tab, CodeEditor as Editor } from '@plesk/ui-library';

class CodeEditor extends Component {
    handleCloseTab = index => e => {
        e.stopPropagation();
        e.preventDefault();

        this.props.onCloseTab(index);
    };

    handleChangeTab = index => () => {
        this.props.onChangeTab(index);
    };

    render() {
        const {
            className,
            readonly,
            autoFocus,
            tabs,
            children,
            onInit,
            onChange,
            onSave,
            onChangeTab,
            onCloseTab,
            ...props
        } = this.props;

        const baseClassName = 'file-manager__code-editor';
        const activeTab = tabs.find(({ active }) => active);

        let tabsBlock = null;
        if (tabs.length) {
            const active = tabs.reduce((found, tab, index) => found || (tab.active ? index : false), false);

            tabsBlock = (
                <Tabs className={`${baseClassName}-tabs`} active={active + 1}>
                    {tabs.map((tab, index) => (
                        <Tab
                            key={tab.title}
                            title={tab.title}
                            onClose={tab.disableClose ? () => {} : this.handleCloseTab(index)}
                            onActivate={tab.active ? null : this.handleChangeTab(index)}
                        />
                    ))}
                </Tabs>
            );
        }

        return (
            <div className={classNames(baseClassName, className)} {...props}>
                {tabsBlock}

                <Editor
                    fileName={activeTab ? activeTab.title : null}
                    autofocus={autoFocus}
                    readOnly={readonly}
                    onInit={onInit}
                    onChange={onChange}
                    onSave={onSave}
                >
                    {children}
                </Editor>
            </div>
        );
    }
}

CodeEditor.propTypes = {
    /**
     * Content of the `CodeEditor`.
     */
    children: PropTypes.any,
    /**
     * Additional class name.
     */
    className: PropTypes.string,
    /**
     * Is not allowed to edit content
     */
    readonly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    tabs: PropTypes.any,
    onInit: PropTypes.func,
    onChangeTab: PropTypes.func.isRequired,
    onCloseTab: PropTypes.func.isRequired,
    /**
     * onChange event handler
     */
    onChange: PropTypes.func,
    /**
     * on save event handler
     */
    onSave: PropTypes.func.isRequired,
};
CodeEditor.defaultProps = {
    children: '',
    className: '',
    readonly: false,
    autoFocus: true,
    tabs: null,
    onInit: null,
    onChange: null,
};

export default CodeEditor;



// WEBPACK FOOTER //
// ./views/smb/file-manager/CodeEditor.js